import { createReducer } from '@reduxjs/toolkit';
import registerToggleAction from '../actions/registerFormToggle';

const initialState = {
  visible: false,
  type: 'register',
};
export default createReducer(initialState, (builder) => {
  builder.addCase(registerToggleAction, (state, action) => action.payload);
});
